import React from "react";
import { Link, Route } from "react-router-dom";

import RequireAuth from "@components/RequireAuth";

import { AUTH_LEVELS } from "@lib/globals";

import Organization from "@LeagueManagement/Organizations/components/Organization";
import OrganizationLoader from "@LeagueManagement/Organizations/loaders/organizationLoader";
import OrganizationsLoader from "@LeagueManagement/Organizations/loaders/organizationsLoader";

import OrgManagementLayout from "@OrgManagement/Layout";

export default (
    <Route element={<RequireAuth allowedUserLevels={AUTH_LEVELS.org} />}>
        <Route
            path="org-management"
            element={<OrgManagementLayout />}
            loader={OrganizationsLoader}
            handle={{
                crumb: () => (
                    <Link to="/org-management">Organization Management</Link>
                ),
            }}
        >
            <Route
                index
                loader={OrganizationLoader}
                element={<Organization />}
                handle={{ header: () => "Organization Management" }}
            />
        </Route>
    </Route>
);
